module.exports = __webpack_public_path__ + "static/footer-weeds-6ee9b1d00c6d13fbd66a9fbd488df55a.png";